var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraggableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44397 0C1.13082 0 0.0626221 1.06827 0.0626221 2.38135C0.0626221 3.69444 1.13037 4.76263 2.44397 4.76263C3.75758 4.76263 4.82533 3.69444 4.82533 2.38135C4.82533 1.06827 3.75706 0 2.44397 0Z",
    fill: "#727E8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1512 0C8.83817 0 7.7699 1.06827 7.7699 2.38135C7.7699 3.69444 8.83817 4.76263 10.1512 4.76263C11.4644 4.76263 12.5328 3.69444 12.5328 2.38135C12.5328 1.06827 11.4649 0 10.1512 0Z",
    fill: "#727E8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3818 12.3932C3.69488 12.3932 4.76337 11.3253 4.76337 10.0119C4.76337 8.69857 3.69488 7.63037 2.3818 7.63037C1.06871 7.63037 0 8.69864 0 10.0119C0 11.3253 1.06871 12.3932 2.3818 12.3932Z",
    fill: "#727E8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.089 12.3932C11.4019 12.3932 12.4703 11.3253 12.4703 10.0119C12.4703 8.69857 11.4027 7.63037 10.089 7.63037C8.77547 7.63037 7.70764 8.69857 7.70764 10.0119C7.70764 11.3253 8.77591 12.3932 10.089 12.3932Z",
    fill: "#727E8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43624 15.2373C1.12315 15.2373 0.0544434 16.3053 0.0544434 17.6187C0.0544434 18.9315 1.12315 19.9999 2.43624 19.9999C3.74932 19.9999 4.81752 18.932 4.81752 17.6187C4.81752 16.3053 3.74932 15.2373 2.43624 15.2373Z",
    fill: "#727E8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1439 15.2373C8.83072 15.2373 7.76208 16.3053 7.76208 17.6187C7.76208 18.9315 8.83035 19.9999 10.1439 19.9999C11.4567 19.9999 12.5252 18.932 12.5252 17.6187C12.5252 16.3053 11.4567 15.2373 10.1439 15.2373Z",
    fill: "#727E8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggableIcon);
export default __webpack_public_path__ + "static/media/draggable-icon.8550305e.svg";
export { ForwardRef as ReactComponent };